import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Search, Filter, Download } from 'lucide-react';
export function AdminAuditLogPage() {
  return <div className="min-h-screen bg-background text-textMain flex flex-col" data-id="element-725">
      <header className="h-16 border-b border-border flex items-center justify-between px-6 bg-surface shrink-0" data-id="element-726">
        <div className="flex items-center gap-4" data-id="element-727">
          <span className="text-xl font-bold text-red-500" data-id="element-728">Booker Admin</span>
          <div className="w-px h-6 bg-border" data-id="element-729"></div>
          <nav className="flex items-center gap-4 text-sm font-medium" data-id="element-730">
            <Link to="/admin" className="text-textMuted hover:text-textMain" data-id="element-731">
              Dashboard
            </Link>
            <Link to="/admin/approvals" className="text-textMuted hover:text-textMain" data-id="element-732">
              Approvals
            </Link>
            <Link to="/admin/audit-log" className="text-textMain" data-id="element-733">
              Audit Log
            </Link>
          </nav>
        </div>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="flex-1 p-8 max-w-7xl mx-auto w-full" data-id="element-734">
        <div className="flex items-center justify-between mb-8" data-id="element-735">
          <div data-id="element-736">
            <h1 className="text-2xl font-bold mb-1" data-id="element-737">Audit Log</h1>
            <p className="text-sm text-textMuted" data-id="element-738">
              Searchable history of sensitive actions.
            </p>
          </div>
          <button className="px-4 py-2 bg-surface border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors flex items-center gap-2" data-id="element-739">
            <Download className="w-4 h-4" data-id="element-740" /> Export CSV
          </button>
        </div>

        <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-741">
          <div className="p-4 border-b border-border flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-742">
            <div className="relative w-full sm:w-96" data-id="element-743">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-textMuted" data-id="element-744" />
              <input type="text" placeholder="Search by actor, action, or object..." className="w-full pl-9 pr-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-745" />
            </div>
            <div className="flex items-center gap-2" data-id="element-746">
              <select className="px-3 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary text-textMuted" data-id="element-747">
                <option data-id="element-748">All Sources</option>
                <option data-id="element-749">GUI</option>
                <option data-id="element-750">API</option>
                <option data-id="element-751">Chat</option>
              </select>
              <button className="px-3 py-2 bg-background border border-border rounded-lg text-sm flex items-center gap-2 hover:bg-surfaceHover" data-id="element-752">
                <Filter className="w-4 h-4" data-id="element-753" /> Filter
              </button>
            </div>
          </div>
          <div className="overflow-x-auto" data-id="element-754">
            <table className="w-full text-sm text-left" data-id="element-755">
              <thead className="text-xs text-textMuted uppercase bg-background/50 border-b border-border" data-id="element-756">
                <tr data-id="element-757">
                  <th className="px-6 py-4 font-medium" data-id="element-758">Timestamp</th>
                  <th className="px-6 py-4 font-medium" data-id="element-759">Actor</th>
                  <th className="px-6 py-4 font-medium" data-id="element-760">Action</th>
                  <th className="px-6 py-4 font-medium" data-id="element-761">Object</th>
                  <th className="px-6 py-4 font-medium" data-id="element-762">Source</th>
                  <th className="px-6 py-4 font-medium" data-id="element-763">Details</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border" data-id="element-764">
                {[{
                time: '2026-06-01 14:32:01',
                actor: 'mark@thewildwoods.com',
                action: 'CREATE',
                object: 'Deal #4829',
                source: 'GUI',
                details: 'Created deal for The Empty Bottle'
              }, {
                time: '2026-06-01 14:30:15',
                actor: 'system',
                action: 'UPDATE',
                object: 'Venue #102',
                source: 'API',
                details: 'Updated capacity from 350 to 400'
              }, {
                time: '2026-06-01 12:15:00',
                actor: 'emma@agency.com',
                action: 'DELETE',
                object: 'Campaign #88',
                source: 'GUI',
                details: 'Deleted draft campaign'
              }, {
                time: '2026-06-01 10:05:22',
                actor: 'mark@thewildwoods.com',
                action: 'EXECUTE',
                object: 'Route Generation',
                source: 'Chat',
                details: 'Prompt: "Plan a June route..."'
              }, {
                time: '2026-05-31 09:00:00',
                actor: 'admin@booker.com',
                action: 'UPDATE',
                object: 'Global Settings',
                source: 'GUI',
                details: 'Changed default fee threshold'
              }].map((log, i) => <tr key={i} className="hover:bg-surfaceHover/50 transition-colors" data-id="element-765">
                    <td className="px-6 py-4 text-textMuted whitespace-nowrap" data-id="element-766">
                      {log.time}
                    </td>
                    <td className="px-6 py-4 font-medium" data-id="element-767">{log.actor}</td>
                    <td className="px-6 py-4" data-id="element-768">
                      <span className={`px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wider ${log.action === 'CREATE' ? 'bg-green-500/10 text-green-500' : log.action === 'DELETE' ? 'bg-red-500/10 text-red-500' : log.action === 'UPDATE' ? 'bg-blue-500/10 text-blue-500' : 'bg-purple-500/10 text-purple-500'}`} data-id="element-769">
                        {log.action}
                      </span>
                    </td>
                    <td className="px-6 py-4" data-id="element-770">{log.object}</td>
                    <td className="px-6 py-4 text-textMuted" data-id="element-771">{log.source}</td>
                    <td className="px-6 py-4 text-textMuted truncate max-w-xs" data-id="element-772">
                      {log.details}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </motion.div>
    </div>;
}